import React, { Fragment } from 'react';
import { graphql } from 'gatsby';

import Img from 'gatsby-image';
import Seo from '../components/Seo';
import {
  PageWrapper,
  PageInner,
  PageTitle,

  Banner,
} from '../components/Elements';

export const dataPrivacyQuery = graphql`
query  dataPrivacyQuery($locale: String){
    
   banner: file(relativePath: { eq: "banner-test.jpg" }) {
      childImageSharp {
          fluid( maxWidth:1920) {
          ...GatsbyImageSharpFluid
        }

      }
    }

    page: datoCmsPageDataProtection(locale: {eq: $locale}) {
      titre
      contenu
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }
  }
`;




const DataPrivacyPage = ({data}) => {
  
  const { titre, contenu, seoMetaTags } = data.page;

  return (
    <Fragment>
      <Seo meta={seoMetaTags} />
      <PageWrapper>
        <Banner height="250px">
          <Img fluid={data.banner.childImageSharp.fluid} />
        </Banner>
        <PageInner>
          <PageTitle>{titre}</PageTitle>
          <div dangerouslySetInnerHTML={{ __html: contenu }} />
        </PageInner>
      </PageWrapper>
    </Fragment>
  );
}

export default  DataPrivacyPage